module.exports = __webpack_public_path__ + "img/flowers-6924088_1280.41a36720.png";